import React, { Component, PureComponent } from 'react'
import Modal from '~/common/modal'
import Form from './Form'

export default function ModalForm(props) {
  let { onClose, children, actions, ...formProps } = props

  if (typeof onClose !== 'function') onClose = () => {}

  return (
    <Modal open={true} onClose={onClose} actions={actions} wrap={Form} {...formProps}>
      {children}
    </Modal>
  )
}
